// Function to filter voucher details by month, year, voucher type, and reduce the amount
const filterAndCountByVoucherType = (voucherDetailsList, targetYear, targetVoucherType) => {
    // Filter vouchers for the target month, year, and voucher type
    const filteredVouchers = voucherDetailsList.filter(voucher => {
       
        const voucherDate = new Date(voucher.missingDate);
        const voucherYear = voucherDate.getFullYear();
        const voucherTypeMatch = voucher.voucherType === targetVoucherType;
        const yearMatch = voucherYear === targetYear;
        return voucherTypeMatch  && yearMatch;
    });

   

    // Count of filtered vouchers
    const count = filteredVouchers.length;

    return  count ;
}

export default filterAndCountByVoucherType;
